/* Glyfa · Conversion-Umbau 21.10.2026
   Produktseite: Galerie (Pfeile, Wischen, Zoom), Größentabelle als Overlay, Menge, Pflicht-Größenwahl,
   Sticky-Kaufleiste am Handy, Bestätigung nach dem Hinzufügen. Kollektion: Filter Typ/Farbe/Größe + Sortierung.
   Läuft nach glyfa.js (beide defer). */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function openDialog(d) {
    if (!d) return;
    if (typeof d.showModal === 'function') { try { d.showModal(); } catch (e) { d.setAttribute('open', ''); } }
    else d.setAttribute('open', '');
  }
  function closeDialog(d) {
    if (!d) return;
    if (typeof d.close === 'function') { try { d.close(); } catch (e) { d.removeAttribute('open'); } }
    else d.removeAttribute('open');
  }
  $$('dialog.dlg').forEach(function (d) {
    d.addEventListener('click', function (e) {
      if (e.target === d || e.target.closest('[data-dlg-close]')) closeDialog(d);
    });
  });

  /* ---------------- Produktseite ---------------- */
  $$('.pdp2[data-product]').forEach(function (root) {
    var main = $('[data-main]', root);
    var form = $('[data-direct-form]', root);
    var addBtn = $('[data-add-direct]', root);
    var isPers = root.hasAttribute('data-pers');

    /* Galerie (nur Bilder der gewählten Farbe; Alt-Text „Produkt – Farbe“ aus der westernprint-App) */
    function slides() { return main ? $$('[data-media]', main) : []; }
    function enabled() { return slides().filter(function (el) { return !el.hasAttribute('data-off'); }); }
    function visibleSlide() {
      var s = slides();
      for (var i = 0; i < s.length; i++) if (!s[i].hidden) return s[i];
      return s[0];
    }
    function current() { return slides().indexOf(visibleSlide()); }
    function showSlide(el) {
      if (!el) return;
      var id = el.getAttribute('data-media');
      var th = $('[data-media-thumb="' + id + '"]', root);
      if (th) th.click();
      else slides().forEach(function (x) { x.hidden = x !== el; });
      paintCount();
    }
    function go(step) {
      var on = enabled();
      if (!on.length) return;
      var k = on.indexOf(visibleSlide());
      if (k < 0) k = 0;
      showSlide(on[(k + step + on.length) % on.length]);
    }
    function paintCount() {
      var c = $('[data-gal-count]', root);
      var on = enabled();
      var k = on.indexOf(visibleSlide());
      var few = on.length < 2; // nur setzen, wenn sich etwas ändert – sonst löst der MutationObserver (hidden) eine Endlosschleife aus
      if (c) { var tx = (k < 0 ? 1 : k + 1) + ' / ' + on.length; if (c.textContent !== tx) c.textContent = tx; if (c.hidden !== few) c.hidden = few; }
      $$('[data-gal-step]', root).forEach(function (b) { if (b.hidden !== few) b.hidden = few; });
    }
    var colorFs = $$('fieldset[data-option]', root).filter(function (fs) { return !!$('.swatches', fs); })[0];
    function curColor() {
      var c = colorFs && $('input:checked', colorFs);
      return c ? String(c.value).toLowerCase().trim() : '';
    }
    function altMatches(alt, color) {
      if (!alt || !color) return false;
      var seg = String(alt).split(' – ').pop().trim();
      return seg === color || seg.indexOf(color + ' ') === 0 || seg.indexOf(color + ',') === 0;
    }
    function applyColor() {
      var color = curColor();
      var s = slides();
      if (!s.length) return;
      var hit = s.filter(function (el) { return altMatches(el.getAttribute('data-alt'), color); });
      var useFilter = hit.length > 0;
      s.forEach(function (el) {
        if (el.hasAttribute('data-nn-live')) { el.removeAttribute('data-off'); return; } // Live-Vorschau bleibt immer
        if (useFilter && hit.indexOf(el) < 0) el.setAttribute('data-off', ''); else el.removeAttribute('data-off');
      });
      $$('[data-media-thumb]', root).forEach(function (b) { b.hidden = !b.hasAttribute('data-nn-live-thumb') && useFilter && !altMatches(b.getAttribute('data-alt'), color); });
      var cur = visibleSlide();
      if (useFilter && cur && cur.hasAttribute('data-off')) showSlide(hit[0]);
      paintCount();
      if (colorFs) {
        var c = $('input:checked', colorFs), lab = $('[data-option-label]', colorFs);
        if (c && lab && c.getAttribute('data-label')) lab.textContent = c.getAttribute('data-label');
      }
    }
    root.addEventListener('change', function (e) { if (colorFs && colorFs.contains(e.target)) applyColor(); });
    applyColor();
    if (main) {
      main.addEventListener('click', function (e) {
        var step = e.target.closest('[data-gal-step]');
        if (step) { e.preventDefault(); go(Number(step.getAttribute('data-gal-step'))); return; }
        var z = e.target.closest('[data-zoom-open]') || e.target.closest('.slide');
        if (z) openZoom();
      });
      var x0 = null, y0 = null;
      main.addEventListener('touchstart', function (e) { var t = e.touches[0]; x0 = t.clientX; y0 = t.clientY; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
        x0 = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3) go(dx < 0 ? 1 : -1);
      }, { passive: true });
      root.addEventListener('click', function (e) { if (e.target.closest('[data-media-thumb]')) setTimeout(paintCount, 0); });
      new MutationObserver(paintCount).observe(main, { subtree: true, attributes: true, attributeFilter: ['hidden'] });
    }

    /* Zoom */
    var zoom = $('[data-zoom]');
    function openZoom() {
      if (!zoom) return;
      var s = visibleSlide();
      if (!s) return;
      var src = s.getAttribute('data-zoom-src');
      var img = $('img', s);
      var stage = $('[data-zoom-stage]', zoom);
      stage.classList.remove('z');
      stage.innerHTML = '';
      var live = s.hasAttribute('data-nn-live') && $('[data-nn-stage]', s);
      if (live) { var cl = live.cloneNode(true); cl.removeAttribute('data-nn-stage'); cl.classList.add('nn-zoom'); stage.appendChild(cl); openDialog(zoom); return; }
      var big = document.createElement('img');
      big.src = src || (img && img.currentSrc) || '';
      big.alt = img ? img.alt : '';
      stage.appendChild(big);
      openDialog(zoom);
    }
    if (zoom) {
      $('[data-zoom-stage]', zoom).addEventListener('click', function (e) {
        var st = e.currentTarget;
        if (e.target.tagName !== 'IMG') return;
        var r = e.target.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
        st.classList.toggle('z');
        if (st.classList.contains('z')) {
          requestAnimationFrame(function () {
            st.scrollLeft = px * st.scrollWidth - st.clientWidth / 2;
            st.scrollTop = py * st.scrollHeight - st.clientHeight / 2;
          });
        }
      });
    }

    /* Größentabelle */
    var sc = $('[data-sizechart]');
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-sizechart-open]')) { e.preventDefault(); openDialog(sc); }
    });

    /* Menge */
    $$('[data-qty]', root).forEach(function (q) {
      var input = $('input', q);
      q.addEventListener('click', function (e) {
        var b = e.target.closest('[data-qty-step]');
        if (!b) return;
        var v = (parseInt(input.value, 10) || 1) + Number(b.getAttribute('data-qty-step'));
        input.value = String(Math.min(99, Math.max(1, v)));
      });
      input.addEventListener('change', function () {
        input.value = String(Math.min(99, Math.max(1, parseInt(input.value, 10) || 1)));
      });
    });

    /* Pflicht-Größenwahl (nur Standardprodukte: Größe ist nicht vorausgewählt) */
    function missing() {
      return $$('fieldset[data-required]', root).filter(function (fs) { return !$('input:checked', fs); });
    }
    function flagMissing(list) {
      list.forEach(function (fs) {
        fs.classList.add('need');
        var m = $('[data-opt-msg]', fs);
        if (m) m.hidden = false;
      });
      if (list[0]) {
        var y = list[0].getBoundingClientRect().top + window.scrollY - 110;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    }
    root.addEventListener('change', function (e) {
      var fs = e.target.closest('fieldset[data-required]');
      if (fs && $('input:checked', fs)) {
        fs.classList.remove('need');
        var m = $('[data-opt-msg]', fs);
        if (m) m.hidden = true;
      }
      syncBar();
    });
    if (form) {
      document.addEventListener('submit', function (e) {
        if (e.target !== form) return;
        var miss = missing();
        if (miss.length) {
          e.preventDefault();
          e.stopImmediatePropagation();
          flagMissing(miss);
        }
      }, true);
    }

    /* Sticky-Kaufleiste (Handy) */
    var bar = $('[data-sbar]');
    var barBtn = bar && $('[data-sbar-btn]', bar);
    var barPrice = bar && $('[data-sbar-price]', bar);
    var priceEl = $('[data-price]', root);
    var mainVisible = true;
    function syncBar() {
      if (!bar) return;
      if (barPrice && priceEl) barPrice.textContent = priceEl.textContent;
      if (barBtn && addBtn && !isPers) barBtn.textContent = addBtn.textContent.trim();
    }
    function showBar() {
      if (!bar) return;
      var on = !mainVisible && window.scrollY > 300;
      bar.classList.toggle('on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (barBtn) barBtn.tabIndex = on ? 0 : -1;
    }
    if (bar && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        mainVisible = es[0].isIntersecting;
        showBar();
      }, { threshold: 0 }).observe(isPers ? (form || addBtn) : addBtn);
      window.addEventListener('scroll', showBar, { passive: true });
      barBtn.addEventListener('click', function () {
        if (isPers) {
          var t = $('[data-nn]', root) || $('[data-lg]', root) || $('.tee-campaign-form-wrapper', root) || form;
          window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - 90, behavior: 'smooth' });
          return;
        }
        var miss = missing();
        if (miss.length) { flagMissing(miss); return; }
        if (addBtn.disabled) return;
        if (typeof form.requestSubmit === 'function') form.requestSubmit(addBtn);
        else addBtn.click();
      });
      syncBar();
      if (priceEl && 'MutationObserver' in window) new MutationObserver(syncBar).observe(priceEl, { childList: true, characterData: true, subtree: true });
    }

    /* Bestätigung nach dem Hinzufügen (Ereignis aus glyfa.js) */
    var added = $('[data-added]');
    var addedTimer;
    document.addEventListener('glyfa:added', function () {
      if (!added) return;
      added.hidden = false;
      clearTimeout(addedTimer);
      addedTimer = setTimeout(function () { added.hidden = true; }, 7000);
    });
    if (added) added.addEventListener('click', function (e) { if (e.target.closest('[data-added-close]')) added.hidden = true; });
  });

  /* ---------------- Kollektion: Filter + Sortierung ---------------- */
  $$('[data-coll]').forEach(function (root) {
    var grid = $('[data-grid]', root);
    var bar = $('[data-fbar]', root);
    if (!grid || !bar) return;
    var cards = $$('.pcard', grid);
    cards.forEach(function (c, i) { c.dataset.order = String(i); });
    var count = $('[data-fcount]', root);
    var empty = $('[data-fempty]', root);
    var reset = $('[data-freset]', root);
    var sort = $('[data-sort]', root);

    function chosen(group) {
      var g = $('[data-fgroup="' + group + '"]', bar);
      if (!g) return [];
      return $$('input:checked', g).map(function (i) { return i.value; });
    }
    function apply() {
      var types = chosen('type'), cols = chosen('colors'), sizes = chosen('sizes');
      var n = 0;
      cards.forEach(function (c) {
        var ct = c.dataset.type || '';
        var cc = (c.dataset.colors || '').split(' ');
        var cs = (c.dataset.sizes || '').split('|');
        var ok = (!types.length || types.indexOf(ct) >= 0) &&
          (!cols.length || cols.some(function (x) { return cc.indexOf(x) >= 0; })) &&
          (!sizes.length || sizes.some(function (x) { return cs.indexOf(x) >= 0; }));
        c.hidden = !ok;
        if (ok) n++;
      });
      if (count) count.textContent = (count.dataset.tpl || '__n__').replace('__n__', String(n));
      if (empty) empty.hidden = n > 0;
      $$('[data-fgroup]', bar).forEach(function (g) {
        var k = $$('input:checked', g).length;
        var fn = $('[data-fn]', g);
        if (fn) fn.textContent = k ? String(k) : '';
      });
      if (reset) reset.hidden = !(types.length || cols.length || sizes.length);
    }
    function doSort() {
      var mode = sort ? sort.value : 'featured';
      var list = cards.slice();
      list.sort(function (a, b) {
        if (mode === 'asc') return Number(a.dataset.price) - Number(b.dataset.price);
        if (mode === 'desc') return Number(b.dataset.price) - Number(a.dataset.price);
        return Number(a.dataset.order) - Number(b.dataset.order);
      });
      list.forEach(function (c) { grid.appendChild(c); });
    }
    bar.addEventListener('change', function (e) {
      if (e.target.matches('[data-sort]')) doSort(); else apply();
    });
    if (reset) reset.addEventListener('click', function () {
      $$('input:checked', bar).forEach(function (i) { i.checked = false; });
      apply();
    });
    document.addEventListener('click', function (e) {
      $$('details.fdrop[open]', bar).forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
    });
    $$('details.fdrop', bar).forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) $$('details.fdrop[open]', bar).forEach(function (o) { if (o !== d) o.removeAttribute('open'); });
      });
    });
    apply();
  });
})();
